export default "__VITE_ASSET__CpTFD08W__"